import {BsCCircle} from "react-icons/bs";

function Footer() {
    return <div className="text-sm font-medium text-gray-900"> <footer><BsCCircle> </BsCCircle> B.N 2025</footer></div>
}
export default Footer